<form novalidate #manageLayoutForm="ngForm" (submit)="saveLayout(false)">
  <div class="row">
    <div class="col-xl-6 manage-col-left">
      <app-card [title]="'admin.inovice_layout.manage.information'|translate">
        <div class="row">
          <div class="form-group form-default form-static-label col-6">
            <label for="name" class="float-label">{{'doctrine.invoice_layout.name'|translate}}   <span
              class="star">*</span></label>
            <input class="form-control"
                   required
                   placeholder="{{'doctrine.invoice_layout.name'|translate}}"
                   name="name"
                   #name="ngModel"
                   id="name"
                   [(ngModel)]="layout.name">
          </div>
          <div class="form-group form-default form-static-label col-6">
            <label class="float-label">{{'global.status'|translate}}<span
              class="star">*</span></label>
            <ng-select required name="status" id="status" [items]="status" bindValue="value"
                       [(ngModel)]="layout.status" [clearable]="false" [searchable]="false"></ng-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group form-default form-static-label col-6">
            <label class="float-label">{{'doctrine.option.type'|translate}}<span
              class="star">*</span></label>
            <ng-select required name="type" id="type" [items]="layoutTypes" bindLabel="label" bindValue="value"
                       [(ngModel)]="layout.isCredit" [clearable]="false" [searchable]="false"></ng-select>
          </div>
        </div>
        <div>
          <div><strong>{{'admin.inovice_layout.manage.custom_fields'| translate }}</strong></div>
          <hr>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="uploaderFile">{{'admin.inovice_layout.manage.upload_logo'| translate }}   <span
              class="star">*</span></label>
            <label class="custom-file" [ngClass]="{'d-none':imageUrl}">
              <input type="file" #uploadEl ng2FileSelect [uploader]="uploader" class="custom-file-input form-control"
                     id="uploaderFile" (change)="fileChange($event)" accept=".gif,.jpg,.jpeg,.png"
                     [disabled]="isSetLayoutType(layout.isCredit)">
              <span class="custom-file-control-upload btn-sm "
                    *ngIf="uploader.queue.length==0">{{"global.choose_file"|translate}}</span>
              <span class="custom-file-control-upload btn-sm "
                    *ngIf="uploader.queue.length>0">{{"global.change_file"|translate}}</span>
              <span
                class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
            </label>
            <div class="row">
              <div *ngIf="imageUrl" class="col-sm-4 text-center">
                <img class="product-img border img-fluid" [src]="imageUrl" #imageElement alt="Selected Logo">
              </div>
              <!--
              Change Button -->
              <div *ngIf="imageUrl" class="col-sm-8">
                <button (click)="changeImage($event)"
                        class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-2">{{'global.change_file'|translate}}</button>
                <!--
                Remove Image -->
                <button *ngIf="imageUrl != null" (click)="removeImage(layout.logo)"
                        type="button"
                        class="btn btn-success btn-sm waves-effect waves-light ">{{'global.delete_file'|translate}}
                </button>
              </div>
            </div>
          </div>
          <div class="form-group col-sm-6 pt-4">
            <button type="button"
                    class="btn btn-primary ripple light btn-sm mt-1"
                    [disabled]="isSetLayoutType(layout.isCredit)"
                    (click)="addCompanyDetails()">{{'admin.inovice_layout.manage.add_company_details'|translate}}</button>
          </div>
        </div>
        <div class="row">
          <div class="form-group form-default form-static-label col-6">
            <label for="title" class="float-label">{{'doctrine.invoice_layout.title'|translate}}   <span
              class="star">*</span></label>
            <input class="form-control"
                   required
                   placeholder="{{'doctrine.invoice_layout.title'|translate}}"
                   name="title"
                   #title="ngModel"
                   id="title"
                   maxlength="28"
                   [(ngModel)]="layout.title"
                   [disabled]="isSetLayoutType(layout.isCredit)">
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-5">
            <label for="header">{{"doctrine.invoice_layout.header" | translate}}</label>
            <div>
              <quill-editor #header="ngModel" [modules]="modules" name="header" id="header"
                            [(ngModel)]="layout.header" [readOnly]="isSetLayoutType(layout.isCredit)"></quill-editor>
            </div>
            <div class="messages text-danger"
                 *ngIf="header.invalid && header.dirty && header.errors?.required">{{'errors.required'|translate}}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-5">
            <label for="footer">{{"doctrine.invoice_layout.footer" | translate}}   <span
              class="star">*</span></label>
            <div>
              <quill-editor required #footer="ngModel" [modules]="modules" name="footer" [(ngModel)]="layout.footer"
                            id="footer" [readOnly]="isSetLayoutType(layout.isCredit)"></quill-editor>
            </div>
            <div class="messages text-danger"
                 *ngIf="footer.invalid && footer.dirty && footer.errors?.required">{{'errors.required'|translate}}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12 text-end">
            <a routerLink="/back-office/invoice-layout/overview" class="btn btn-link"
               type="button">{{'global.cancel'|translate}}</a>
            <button type="submit" class="btn btn-primary ripple light"
                    [disabled]="manageLayoutForm.invalid || !isValid()">{{(isEdit ? 'global.save_changes' : 'global.add')|translate}}</button>
          </div>
        </div>
      </app-card>
    </div>
    <!--------------------- PREVIEW BOX--------------------------------->
    <div class="col-xl-6 manage-col-right">
      <app-card [title]="'admin.inovice_layout.manage.layout_preview'|translate">
        <div class="row">
          <div class="col-xl-12">
            <ng-container *ngIf="!iframeUrl">{{'admin.invoice_layout.manage.preview_message'|translate}}
            </ng-container>
            <iframe *ngIf="iframeUrl" [src]="iframeUrl" width="100%" height='625px'
                    class="email-preview"></iframe>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-xl-12">
            <button type="button"
                    class="btn btn-sm btn-primary ripple light"
                    [disabled]="manageLayoutForm.invalid || !isValid()"
                    (click)="preview()">{{ 'global.preview' | translate}}
            </button>
          </div>
        </div>
      </app-card>
    </div>
  </div>
  <!--------------------- END PREVIEW BOX----------------------------->
</form>


<app-modal-basic #companyDetailsModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.inovice_layout.manage.company_information'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="companyDetailsModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addCompanyDetailsForm="ngForm" (ngSubmit)="manageCompanyDetails()">
      <p>{{'admin.inovice_layout.manage.add_company_information_help'|translate}}</p>
      <div class="col-md-12 d-flex justify-content-between p-0">
        <p class="m-0"><b>{{'admin.inovice_layout.manage.add_company_information_row'| translate}}</b></p>
      </div>
      <hr>
      <ng-container *ngFor="let companyDetail of companyDetails; let i = index;">
        <div class="form-row row">
          <div class="form-group col-md-6">
            <label
              [for]="'row' + i">{{"admin.inovice_layout.manage.add_company_information_row_number" | translate:{'number': i + 1} }}
              <span
                class="star">*</span></label>
            <input [name]="'invoiceLayoutDetails[content][' + i+']'"
                   [id]="'invoiceLayoutDetails[content][' + i+']'"
                   class="form-control"
                   #detailsContent="ngModel"
                   [(ngModel)]="companyDetail.content" maxlength="28">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="detailsContent.invalid && detailsContent.dirty && detailsContent.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="col-md-6 form-group pt-4">
            <button tabindex="-1" class="btn btn-primary btn-icon" type="button" *ngIf="i > 0"
                    (click)="removeCompanyDetails(i)">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </ng-container>
      <div class="row">
        <div class="col-12">
          <button type="button" class="btn btn-primary custom-btn-sm btn-sm ripple light float-left"
                  (click)="addNewRow()"><i class="fa fa-plus"></i>
            {{'admin.inovice_layout.manage.add_new_row' | translate}}
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="companyDetailsModal.hide();">{{'global.cancel'|translate}}</button>

    <button type="submit"
            class="btn btn-primary ripple light"
            [disabled]="addCompanyDetailsForm.invalid"
            (click)="manageCompanyDetails()">{{(isEdit ? 'global.actions.save' : 'global.add')| translate}}
    </button>
  </div>
</app-modal-basic>
